import clsx from 'clsx';
import React from 'react';

import styles from './CircleLoader.module.scss';

interface LoaderProps {
  className?: string;
  classNameLoader?: string;
  small?: boolean;
  id?: any;
}

export const CircleLoader: React.FC<LoaderProps> = ({ className, classNameLoader, small, id }) => (
  <div
    className={clsx(styles.wrapper, className)}
    id={id}
  >
    <span className={clsx(styles.loader, classNameLoader, { [styles.small]: small })} />
  </div>
);
